module.exports = __webpack_public_path__ + "img/bus_grey.e40e0ffb.svg";